module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-3-nad_600px_width-0_1.7e3a4725.png";